import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/Badge';

export interface OriginBadgeProps {
  origin: 'global' | 'local';
  className?: string;
  'data-testid'?: string;
}

/**
 * Wspólny badge pochodzenia typu dokumentu (globalny vs własny firmy).
 * Współdzielony przez tabelę typów u tenanta, panel typów globalnych (ITE)
 * i okno przypisania layoutu — jedno źródło stylu/etykiety zamiast trzech kopii.
 */
export function OriginBadge({ origin, className, 'data-testid': dataTestId }: OriginBadgeProps) {
  const { t } = useTranslation();

  if (origin === 'global') {
    return (
      <Badge color="blue" className={className} data-testid={dataTestId}>
        {t('tenant.documentTypes.origin.system')}
      </Badge>
    );
  }

  return (
    <Badge color="gray" className={className} data-testid={dataTestId}>
      {t('tenant.documentTypes.origin.own')}
    </Badge>
  );
}
